import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

import { Eyebrow } from "@/components/landing/SiteLayout";

export const FAQ_ITEMS = [
  { q: "Was ist Liftblick.ch?", a: "Liftblick.ch ist eine Schweizer Plattform, die Kunden hilft, passende Liftanbieter zu finden. Sie erfassen Ihr Projekt online. Registrierte Liftanbieter sehen Ihre Anfrage im Portal und melden sich direkt bei Ihnen." },
  { q: "Wie finde ich einen Liftanbieter?", a: "Sie erfassen Ihre Liftanfrage online mit Angaben zu Liftart, Gebäude und Standort. Passende Liftanbieter sehen Ihre Anfrage und kontaktieren Sie direkt." },
  { q: "Ist die Anfrage kostenlos?", a: "Ja. Die Anfrage über Liftblick.ch ist für Kunden kostenlos und unverbindlich." },
  { q: "Wer kontaktiert mich?", a: "Registrierte Liftanbieter, die zu Ihrer Anfrage passen, melden sich direkt über die angegebenen Kontaktdaten." },
  { q: "Wann erfahre ich Preise?", a: "Konkrete Preise erhalten Sie direkt vom Liftanbieter. Die Kosten hängen vom Gebäude, der Liftart, der baulichen Situation und der Ausstattung ab." },
  { q: "Verkauft Liftblick.ch selbst Lifte?", a: "Nein. Liftblick.ch verkauft keine Lifte und erstellt keine Angebote. Die Plattform verbindet Kunden mit registrierten Liftanbietern." },
  { q: "Kann ich auch Wartung oder Modernisierung anfragen?", a: "Ja. Über Liftblick.ch können Sie auch Anfragen für Aufzugswartung, Service, Anbieterwechsel oder Liftmodernisierung erfassen." },
];

export function FAQSection({ injectJsonLd = false }: { injectJsonLd?: boolean }) {
  useEffect(() => {
    if (!injectJsonLd) return;
    const ldId = "liftblick-faq-jsonld";
    document.getElementById(ldId)?.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = ldId;
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => { document.getElementById(ldId)?.remove(); };
  }, [injectJsonLd]);

  return (
    <section id="faq" className="py-14 sm:py-20 bg-[#F7F8FA] scroll-mt-16">
      <div className="max-w-3xl mx-auto px-6">
        <div className="mb-10 mx-auto">
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="mt-6 text-3xl sm:text-[40px] font-semibold tracking-[-0.03em] text-foreground leading-[1.1]">
            Häufige Fragen.
          </h2>
          <p className="mt-5 text-[14.5px] text-muted-foreground leading-[1.7] max-w-md">
            Antworten zur Plattform, zum Anfrageprozess und zum Anbieterportal.
          </p>
        </div>

        <div className="rounded-2xl bg-background px-2 sm:px-3">
          <Accordion type="multiple" className="w-full">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-0 group">
                <AccordionTrigger className="text-left text-[15.5px] font-semibold text-foreground hover:no-underline py-5 px-4 sm:px-5 rounded-xl transition-colors hover:bg-[#F7F8FA] data-[state=open]:bg-[#F7F8FA]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14.5px] text-muted-foreground leading-[1.75] pb-5 px-4 sm:px-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>


        <div className="mt-8 text-center">
          <a href="mailto:info@liftblick.ch" className="inline-flex items-center gap-1.5 text-[13px] font-medium text-foreground hover:underline underline-offset-4">
            Weitere Frage stellen
          </a>
        </div>
      </div>
    </section>
  );
}
